<div class="input-currency-wrapper" [ngClass]="{'left': !right, 'right' : right}">
  <ng-content></ng-content>
</div>
